import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AnchorLink } from '@pearsontechnology/aero-components';

export default function StyledLink({ children, ...props }) {
  return (
    <AnchorLink as={Link} {...props}>
      {children}
    </AnchorLink>
  );
}

StyledLink.propTypes = {
  children: PropTypes.node,
};
